<template>
    <div class="position-relative mb-11">
        <work-findings cardTitle="Work Findings"></work-findings>
    </div>
</template>

<script>
    import WorkFindings from './list.vue';
    export default {
        name: 'check-list-work-findings',
        components: {
            WorkFindings,
        }
    }
</script>
